var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTriangleDiagonalSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 75,
    viewBox: "0 0 140 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.65 51.0006L97.8066 58.2578L102.819 56.3872L100.65 51.0006Z",
    fill: "#524986"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.79 63.7419L102.984 70.999L107.958 69.1209L105.79 63.7419Z",
    fill: "#524986"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2242 51.0006L82.4181 58.2578L87.3926 56.3872L85.2242 51.0006Z",
    fill: "#524986"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3937 63.7414L87.5576 70.9985L92.5696 69.1204L90.3937 63.7414Z",
    fill: "#524986"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8274 51.0006L66.9912 58.2578L71.9957 56.3872L69.8274 51.0006Z",
    fill: "#524986"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9749 63.7414L72.1688 70.9985L77.1433 69.1204L74.9749 63.7414Z",
    fill: "#524986"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4009 51.0006L51.6023 58.2578L56.5768 56.3872L54.4009 51.0006Z",
    fill: "#524986"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5781 63.7414L56.742 70.9985L61.7465 69.1204L59.5781 63.7414Z",
    fill: "#524986"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0134 51.0006L36.1698 58.2578L41.1818 56.3872L39.0134 51.0006Z",
    fill: "#524986"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1525 63.7414L41.3464 70.9985L46.3209 69.1204L44.1525 63.7414Z",
    fill: "#524986"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5866 51.0006L20.7805 58.2578L25.755 56.3872L23.5866 51.0006Z",
    fill: "#524986"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7638 63.7414L25.9201 70.9985L30.9321 69.1204L28.7638 63.7414Z",
    fill: "#524986"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4314 25.5326L87.5952 32.7822L92.5997 30.9116L90.4314 25.5326Z",
    fill: "#524986"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5704 38.2663L92.7642 45.5234L97.7462 43.6453L95.5704 38.2663Z",
    fill: "#524986"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M75.005 25.5326L72.1989 32.7822L77.2109 30.9116L75.005 25.5326Z",
    fill: "#524986"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3461 45.5234L82.3506 43.6453L80.1822 38.2663L77.3461 45.5234Z",
    fill: "#524986"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6156 25.5326L56.8094 32.7822L61.7839 30.9116L59.6156 25.5326Z",
    fill: "#524986"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9486 45.5234L66.9606 43.6453L64.7547 38.2663L61.9486 45.5234Z",
    fill: "#524986"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1137 0.0575175L77.3076 7.34473L82.2821 5.43653L80.1137 0.0575175Z",
    fill: "#524986"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2916 12.7914L82.448 20.0786L87.46 18.1779L85.2916 12.7914Z",
    fill: "#524986"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7182 0.0575175L61.882 7.34473L66.894 5.43653L64.7182 0.0575175Z",
    fill: "#524986"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8648 12.7914L67.0587 20.0786L72.0332 18.1779L69.8648 12.7914Z",
    fill: "#524986"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1894 25.5326L41.3833 32.7822L46.3878 30.9116L44.1894 25.5326Z",
    fill: "#524986"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5609 45.5234L51.5354 43.6453L49.3595 38.2663L46.5609 45.5234Z",
    fill: "#524986"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7939 25.5326L25.9878 32.7822L30.9623 30.9116L28.7939 25.5326Z",
    fill: "#524986"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1343 45.5234L36.1388 43.6453L33.9329 38.2663L31.1343 45.5234Z",
    fill: "#524986"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3676 25.5326L10.5615 32.7822L15.5735 30.9116L13.3676 25.5326Z",
    fill: "#524986"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7385 45.5234L20.713 43.6453L18.5446 38.2663L15.7385 45.5234Z",
    fill: "#524986"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2926 0.0575175L46.494 7.34473L51.4685 5.43653L49.2926 0.0575175Z",
    fill: "#524986"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4693 12.7914L51.6331 20.0786L56.6451 18.1779L54.4693 12.7914Z",
    fill: "#524986"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9033 0.0575175L31.0672 7.34473L36.0717 5.43653L33.9033 0.0575175Z",
    fill: "#524986"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0428 12.7914L36.2367 20.0786L41.2112 18.1779L39.0428 12.7914Z",
    fill: "#524986"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4772 0.0575175L15.6711 7.34473L20.6831 5.43653L18.4772 0.0575175Z",
    fill: "#524986"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6544 12.7914L20.8107 20.0786L25.8228 18.1779L23.6544 12.7914Z",
    fill: "#524986"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25684 5.43653L3.08097 0.0575175L0.282335 7.34473L5.25684 5.43653Z",
    fill: "#524986"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2279 12.7914L5.42177 20.0786L10.4263 18.1779L8.2279 12.7914Z",
    fill: "#524986"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleDiagonalSmall);
export default __webpack_public_path__ + "static/media/triangle-diagonal-small.c7d173f0.svg";
export { ForwardRef as ReactComponent };